<div class="panel panel-default">
    <div class="panel-heading">
        <strong>Backup Summary {{backupname}}</strong>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th width="70%">Media Label</th>
                  <th width="30%">Media Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Media Name 1</td>
                  <td>Media Type 1</td>
                </tr> 
                <tr>
                  <td>Media Name 2</td>
                  <td>Media Type 2</td>
                </tr> 
                <tr>
                  <td>Media Name 3</td>
                  <td>Media Type 3</td>
                </tr> 
                <tr>
                  <td>Media Name 4</td>
                  <td>Media Type 4</td>
                </tr> 
              </tbody> 
            </table>
        </div>
    </div>
    <div class="panel-footer ">
        <i>Last updated on Jan 23, 2020</i>
    </div>
</div>